import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { history } from "../utils";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import getOrderStatus from "../utils/getOrderStatus";
import { ORDER_STATUS } from "../model/order";

const useGuardCustomerRoute = ({ matchOrder } = { matchOrder: false }) => {
  const localstorageCustomer = localStorage.getItem("selectedCustomer");
  const localstorageAgent = localStorage.getItem("selectedAgent");

  const { customerId } = useParams();
  const { order } = useSelector((state) => state.yodaOrders);
  const { me } = useSelector((state) => state.yodaStakeholders);
  const { customer } = useSelector((state) => state.yodaCustomer);

  const { status } = getOrderStatus(order);

  const validateClientOnRoute = useCallback(
    (matchOrder) => {
      if (me?.role && matchOrder) {
        const userTypeDic = {
          Customer: () => {
            //customer role
            if (status == ORDER_STATUS.CANCELLED) {
              return history.replace({
                pathname: "/homepage",
              });
            }
            //if the order is not associated to the customer, redirect
            if (
              order?.stakeholderId &&
              localstorageCustomer != order?.stakeholderId
            ) {
              history.replace({
                pathname: "/not-authorized",
                state: { authError: "Order belongs to another customer" },
              });
            }
          },
          Agents: () => {
            //agent role
            if (status == ORDER_STATUS.CANCELLED) {
              return history.replace({
                pathname: "/homepage",
              });
            }
            if (
              order?.stakeholderId &&
              localstorageCustomer != order?.stakeholderId
            ) {
              //if the order is associated to this agent, update localstorage
              if (
                (order?.agentId && localstorageAgent == order.agentId) ||
                (order?.agent1Id && localstorageAgent == order.agent1Id)
              ) {
                localStorage.setItem("selectedCustomer", order.stakeholderId);
                window.location.reload();
                //if the agent does not match, redirect
              } else {
                history.replace({
                  pathname: "/not-authorized",
                  state: {
                    authError: "Order is not associated with this agent",
                  },
                });
              }
            }
          },
          CustomerCare: () => {
            //customer care role
            if (status == ORDER_STATUS.CANCELLED) {
              return history.replace({
                pathname: "/homepage",
              });
            }
            if (order?.agentId || order?.agent1Id || order?.stakeholderId) {
              let updatedAgent, updatedCustomer;
              if (order?.agentId && localstorageAgent != order.agentId) {
                updatedAgent = order.agentId;
              }
              if (order?.agent1Id && localstorageAgent != order.agent1Id) {
                updatedAgent = order.agent1Id;
              }
              if (
                order?.stakeholderId &&
                localstorageCustomer != order.stakeholderId
              ) {
                updatedCustomer = order.stakeholderId;
              }
              if (updatedAgent)
                localStorage.setItem("selectedAgent", updatedAgent);
              if (updatedCustomer) {
                localStorage.setItem("selectedCustomer", updatedCustomer);
                if (!updatedAgent) {
                  localStorage.removeItem("selectedAgent");
                }
              }
              if (updatedAgent || updatedCustomer) {
                window.location.reload();
              }
            }
          },
        };
        userTypeDic[me.role]?.();
      }
    },
    [
      localstorageAgent,
      localstorageCustomer,
      status,
      me?.role,
      order?.agent1Id,
      order?.agentId,
      order?.stakeholderId,
    ],
  );

  useEffect(() => {
    validateClientOnRoute(matchOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localstorageCustomer, customer, me, validateClientOnRoute]);

  useEffect(() => {
    if (
      customerId &&
      me?.role === "Customer" &&
      me?.id &&
      customerId != me.id
    ) {
      history.replace("/not-authorized");
    }
  }, [customerId, me?.role, me?.id]);

  useEffect(() => {
    if (matchOrder && status == ORDER_STATUS.CANCELLED) {
      return history.replace({
        pathname: "/homepage",
      });
    }
    if (
      customerId &&
      localstorageCustomer != customerId &&
      me?.role === "CustomerCare"
    ) {
      localStorage.setItem("selectedCustomer", customerId);
      window.location.reload();
    }
  }, [customerId, localstorageCustomer, me?.role, status, matchOrder]);

  return {
    validateClientOnRoute,
  };
};

export default useGuardCustomerRoute;
